import { mapGetters, mapActions } from 'vuex';
import { isMarketSingle, marketUserGainLoss, roundToTwo } from '@/utils/helpers';
import { MODALS } from '@/components/app/app-modals/modals-constants';

export default {
  props: {
    market: {
      type: Object,
      required: true,
    },
    theme: {
      type: String,
      required: false,
      default: '',
    },
    showLabels: {
      type: Boolean,
      default: true,
    },
    showMarketLink: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
    ...mapGetters('user', ['isLoggedIn']),
    userGainLoss() {
      const value = marketUserGainLoss(this.market);

      return roundToTwo(value) === 0 ? 0 : value;
    },
    isAllPayoutsAvailable() {
      return !isMarketSingle(this.market);
    },
    gainIndicatorClassModifier() {
      return {
        'market-payout-sushi__gain': true,
        'market-payout-sushi__going-down': !this.userGainLoss,
      };
    },
    classModifiers() {
      return {
        'market-payout-sushi': true,
        [`market-payout-sushi--${this.theme}`]: this.theme,
      };
    },
    gainLossLabel() {
      if (this.userGainLoss > 0) {
        return 'Gain';
      }

      return this.userGainLoss < 0 ? 'Loss' : 'Gain/Loss';
    },
  },
  methods: {
    ...mapActions('popup', ['setGenericPopup']),
    allPayouts() {
      // because there is no routing for modals
      this.setGenericPopup({
        name: MODALS.POTENTIAL_PAYOUTS,
        options: {
          market: this.market,
        },
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-payout-sushi/market-payout-sushi.js